import { useEffect, useState } from 'react';
import type React from 'react';

const TOUR_DISMISS_KEY = 'plng-ergonomics-tour-dismissed-v1';

// ---------------------------------------------------------------------------
// Хук — авто-показ тура при первом скролле к таблице.
// Использует sessionStorage как «soft»-память (не показывать ещё раз
// в этой же сессии вкладки).
// ---------------------------------------------------------------------------

export function useErgonomicsTour(targetRef: React.RefObject<HTMLElement | null>) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let dismissed = false;
    try {
      dismissed = sessionStorage.getItem(TOUR_DISMISS_KEY) === '1';
    } catch {
      // ignore — приватный режим
    }
    if (dismissed) return;

    const el = targetRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;

    let fired = false;
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (!fired && e.isIntersecting && e.intersectionRatio >= 0.3) {
            fired = true;
            io.disconnect();
            const timer = window.setTimeout(() => {
              setOpen(true);
              try {
                sessionStorage.setItem(TOUR_DISMISS_KEY, '1');
              } catch {
                // ignore
              }
            }, 350);
            return () => window.clearTimeout(timer);
          }
        }
      },
      { threshold: [0, 0.3, 0.6] },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [targetRef]);

  return { open, openTour: () => setOpen(true), closeTour: () => setOpen(false) };
}
